import React from "react";
import { NavLink } from "react-router-dom";
import { BookOpen, PlayCircle } from "lucide-react";

/** Переключатель «Читать / Смотреть»: статьи ↔ видеоматериалы (лекции, вебинары, мастер-классы).
 *  Выбранная специальность сохраняется — она хранится в общем контексте, а не в адресе. */
export default function ReadWatchToggle() {
  return (
    <div className="rw-toggle" role="group" aria-label="Формат материалов">
      <NavLink to="/articles" className={({ isActive }) => `rw-opt${isActive ? " active" : ""}`}>
        <BookOpen size={16} strokeWidth={2.1} /> Читать
      </NavLink>
      <NavLink to="/lectures" className={({ isActive }) => `rw-opt${isActive ? " active" : ""}`}>
        <PlayCircle size={16} strokeWidth={2.1} /> Смотреть
      </NavLink>
    </div>
  );
}
